import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  state: {
    [url: string]: {
      position: number;
      [section: string]: number;
    }
  } = {}

  constructor() { }
}
